import { canNormalizeSchemaParam } from './canNormalizeSchemaParam'

/**
 * Returns a patch of store state to apply when normalizing to schema default.
 * For face_count/target_polycount, uses state.polyCount (low/medium/high) to pick min/default/max.
 * Returns null if schema key is not normalizable or propSchema has no default.
 */
export function getDefaultStorePatchForSchemaParam(schemaKey, propSchema, settings) {
  if (!canNormalizeSchemaParam(schemaKey) || propSchema?.default === undefined) {
    return null
  }

  const defaultValue = propSchema.default

  if (schemaKey === 'generate_type') {
    return { generateType: defaultValue }
  }

  if (schemaKey === 'polygon_type') {
    return { polygonType: defaultValue }
  }

  if (schemaKey === 'face_count' || schemaKey === 'target_polycount') {
    const { minimum, maximum } = propSchema
    const polyCount = settings?.polyCount
    if (polyCount === 'low') {
      return { targetPolycount: minimum ?? defaultValue }
    }
    if (polyCount === 'high') {
      return { targetPolycount: maximum ?? defaultValue }
    }
    if (polyCount === 'medium') {
      return { targetPolycount: defaultValue ?? minimum }
    }

    const currentValue = settings?.targetPolycount
    if (currentValue > 0) {
      if (maximum && currentValue > maximum) {
        return { targetPolycount: maximum }
      }
      if (minimum && currentValue < minimum) {
        return { targetPolycount: minimum }
      }

      return { targetPolycount: currentValue }
    }

    return { targetPolycount: defaultValue ?? minimum }
  }

  if (schemaKey === 'material') {
    return { material: defaultValue }
  }

  return null
}
